import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { Link } from "@/components/_molecules/navigation-controls/link";
import { useDocumentTitle } from "@/hooks/use-document-title";

import LoginForm from "../components/login-form";

import AuthPageLayout from "./auth-page.layout";

export function LoginPage() {
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect");
  const { t } = useTranslation("auth");
  useDocumentTitle(t("login.title"));

  return (
    <AuthPageLayout>
      <div className="flex flex-col items-center justify-center space-y-3 border-b px-4 py-6 pt-8 text-center sm:px-16">
        <h3 className="text-xl font-semibold">{t("login.title")}</h3>
        <p className="text-sm">{t("login.subtitle")}</p>
      </div>

      <LoginForm redirect={redirect} />

      <p className="mb-8 text-center text-sm ">
        {t("login.forgotPassword")}{" "}
        <Link to="/forgot-password" className="font-semibold">
          {t("login.resetPassword")}
        </Link>{" "}
      </p>

      <p className="mb-6 text-center text-xs text-muted-foreground">
        <Link to="/accessibility">{t("login.accessibilityStatement")}</Link>
      </p>
    </AuthPageLayout>
  );
}
